module.exports = __webpack_public_path__ + "img/sidebar-icon-daily-report.bbf5aaa9.svg";